import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { fetchSearchResults, updateSearchField } from './../store/slices/searchSlice'; 
import { useNavigate } from "react-router-dom";


const CategoryGrid = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Récupération des catégories depuis le Redux store
    const { categories, status, error } = useSelector((state) => state.categories);

    // // Si l'état est en train de charger, on affiche un message de chargement
    // if (status === 'loading') {
    //     return <div>Chargement des catégories...</div>;
    // }

    // // En cas d'erreur
    // if (status === 'failed') {
    //     return <div>Erreur de chargement : {error}</div>;
    // }

    const handleCategorySet = (subCategory) => {
        // Mettre à jour la valeur de `query` avec le nom de la sous-catégorie
        dispatch(updateSearchField({ field: 'query', value: subCategory?.name }));
        const searchData = {
            categoryId: subCategory?.id || null,
            filtre: [],
            disponibilite:'all-time',
            when: "all_time",
            sortBy: "relevance",
            search_query:subCategory?.name,
            query:subCategory?.name
          };
        // Mettre à jour la valeur de `categoryId` avec l'ID de la sous-catégorie
        dispatch(updateSearchField({ field: 'categoryId', value: subCategory?.id }));
        dispatch(fetchSearchResults(searchData));
        navigate("/resultats", { replace: true });
    };

    return (
        <div className='container space-bloc'>
            {status === 'loading' ? (
                <Skeleton count={10} />
            ) : (
                <>
                    <h2 className='grey600 mb-0'>Nous avons ce que vous cherchez</h2>
                    <div className="category-grid-container mt-32">
                        {categories && categories.map((category) => (
                            <div key={category.id} className="category-item" onClick={() => handleCategorySet(category)}>
                                <img
                                    src={`${process.env.REACT_APP_FILE_URL}${category.icon}`}
                                    alt={category.name}
                                    className="category-icon"
                                />
                                <span className="category-name">{category.name}</span>
                            </div>
                        ))}
                    </div>
                </>
            )
            }
        </div >
    );
};

export default CategoryGrid;
